import * as React from 'react';
import { observer } from 'mobx-react';
import { inject } from '../../../../utils';
import { withTheme } from 'styled-components';

// StyledComponents
import ToastInfo from './StyledComponents/ToastInfo';
import ToastError from './StyledComponents/ToastError';
import ToastWarning from './StyledComponents/ToastWarning';
import ToastSuccess from './StyledComponents/ToastSuccess';
import ToastText from './StyledComponents/ToastText';
import ToastCloseWrapper from './StyledComponents/ToastCloseWrapper';
import ToastCloseButton from './StyledComponents/ToastCloseButton';
import ToastCloseIcon from './StyledComponents/ToastCloseIcon';

import Translate from '../../../Translate';
import { ToastProps } from './Models/ToastProps';
import { ThemeableComponent } from '../../../../utils/theme/ThemeableComponent';
import { ToastThemeKeys, FeedbackType } from './Models';
import { KEYBOARD_KEYS } from '../../../../constants';
import { computed } from 'mobx';

@inject('accessibilityStore')
@observer
class Toast extends ThemeableComponent<ToastProps, {}, ToastThemeKeys> {
    DEFAULT_THEME_KEYS: ToastThemeKeys = {
        base: 'ToastBase',
        success: 'ToastSuccess',
        error: 'ToastError',
        warning: 'ToastWarning',
        info: 'ToastInfo',
        text: 'ToastText',
        closeWrapper: 'ToastCloseWrapper',
        closeButton: 'ToastCloseButton',
        closeIcon: 'ToastCloseIcon',
    };

    constructor(props: ToastProps) {
        super(props);
    }

    getComponentFromType = (type: FeedbackType) => {
        switch (type) {
            case FeedbackType.error:
                return ToastError;
            case FeedbackType.success:
                return ToastSuccess;
            case FeedbackType.warning:
                return ToastWarning;
            case FeedbackType.info:
            default:
                return ToastInfo;
        }
    };

    handleClose = () => {
        const { toastStore } = this.props;
        toastStore.removeToast();
    };

    handleOnKeyUp = (event: KeyboardEvent) => {
        if (event.key === KEYBOARD_KEYS.ESCAPE) {
            event.stopPropagation();
            const { toastStore } = this.props;
            toastStore.removeToast();
        }
    };

    @computed
    get toastComponentTheme() {
        const { toastStore } = this.props;
        const { type } = toastStore;

        switch (type) {
            case FeedbackType.error:
                return this.getTheme('error');
            case FeedbackType.success:
                return this.getTheme('success');
            case FeedbackType.warning:
                return this.getTheme('warning');
            case FeedbackType.info:
            default:
                return this.getTheme('info');
        }
    }

    render() {
        const { toastStore, accessibilityStore } = this.props;
        const { text, closeIcon, showClose, type, key } = toastStore;
        const ToastComponent = this.getComponentFromType(type);
        return (
            <ToastComponent
                tabIndex={0}
                onClick={!showClose ? this.handleClose : undefined}
                onKeyUp={e => this.handleOnKeyUp(e)}
                {...this.getTheme('base')}
                {...this.toastComponentTheme}
            >
                <ToastText id={key} {...this.getTheme('text')}>
                    <Translate>{text}</Translate>
                </ToastText>
                {showClose && (
                    <ToastCloseWrapper {...this.getTheme('closeWrapper')}>
                        <ToastCloseButton
                            aria-label={accessibilityStore.buttonAccessibilityValue(
                                'ToastCloseButton'
                            )}
                            aria-describedby={key}
                            onClick={this.handleClose}
                            {...this.getTheme('closeButton')}
                        >
                            <ToastCloseIcon
                                fileName={closeIcon}
                                aria-hidden={true}
                                {...this.getTheme('closeIcon')}
                            />
                        </ToastCloseButton>
                    </ToastCloseWrapper>
                )}
            </ToastComponent>
        );
    }
}

export default withTheme(Toast) as any;



// WEBPACK FOOTER //
// ./src/Components/Feedback/Components/Toast/Toast.tsx